import { connect } from 'react-redux';
import { getRomSortedList, getRomsSearchCriteria } from '../selectors';
import { getRoms } from '../actions';
import RomList from './List';

const mapStateToProps = state => ({ 
    list: getRomSortedList(state),
    searchCriteria: getRomsSearchCriteria(state)
});

export default connect(mapStateToProps, { getRoms })(RomList);
